"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCE_ROLE_SPEAKER = exports.SOURCE_ROLE_HOST = void 0;
var SOURCE_ROLE_SPEAKER = exports.SOURCE_ROLE_SPEAKER = 'speaker';
var SOURCE_ROLE_HOST = exports.SOURCE_ROLE_HOST = 'host';